import React from 'react';

import { Image } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { Colors } from 'app/utils/colors';
import classNames from 'classnames';
import Button from 'app/components/Button';
import Icon from 'app/components/Icon';

import { PROP_TYPES } from 'app/components/EcommerceConnectorCard/utils/types';

import 'app/components/EcommerceConnectorCard/EcommerceConnectorCard.scss';

export default function EcommerceConnectorCard({
  id,
  image,
  isBlackFridayActive = false,
  isChristmasActive = false,
  status
}) {
  const intl = useIntl();
  const { bbSecondary } = Colors;
  const conectorPurchased = status === 'ACTIVE' || status === 'PURCHASED';
  const onClickButton = () => {
    window.open(
      `${process.env.REACT_APP_BIGBUY_URL}subscription/checkout?serviceProductId=${id}`,
      '_blank'
    );
  };

  return (
    <div
      className={classNames('bb-ecommerce-connector-card', {
        'bb-ecommerce-connector-card--border': conectorPurchased
      })}
    >
      {isBlackFridayActive && (
        <div className="bb-ecommerce-connector-card__black-friday-badge">
          <p className="bb-ecommerce-connector-card__black-friday-badge__text">
            50% OFF
          </p>
        </div>
      )}
      {isChristmasActive && (
        <div className="bb-ecommerce-connector-card__christmas-badge">
          <p className="bb-ecommerce-connector-card__christmas-badge__text">
            50% OFF
          </p>
        </div>
      )}
      <div className="bb-ecommerce-connector-card__container">
        <div className="bb-ecommerce-connector-card__container__images">
          <Image src={image} />
        </div>
        {conectorPurchased && (
          <div
            className="bb-ecommerce-connector-card__container__text"
            style={{
              justifyContent: conectorPurchased ? 'flex-end' : 'center'
            }}
          >
            <p className="medium">
              {status === 'ACTIVE' &&
                intl.formatMessage({ id: 'controlpanel.global.active' })}
              {status === 'PURCHASED' &&
                intl.formatMessage({ id: 'controlpanel.global.purchased' })}
            </p>
          </div>
        )}
        <div className="bb-ecommerce-connector-card__container__button">
          <Button
            icon={<Icon icon="shopping-cart" color={bbSecondary} />}
            onClick={onClickButton}
            size="medium"
            text={intl.formatMessage({ id: 'controlpanel.global.buy' })}
          />
        </div>
      </div>
    </div>
  );
}

EcommerceConnectorCard.propTypes = PROP_TYPES;
